const recipesToItemListJsonLd = (recipes, siteUrl) => ({
  "@context": "https://schema.org/",
  "@type": "ItemList",
  itemListElement: recipes.map((recipe, index) => ({
    "@type": "ListItem",
    position: index + 1,
    url: `${siteUrl}/recipes/${recipe.id}`,
    name: recipe.recipe_name,
  })),
});

export default recipesToItemListJsonLd;
